import styled from 'styled-components';

const SVG_Wrapper = styled.div`
    color: ${({ isSelected, theme }) => isSelected ? theme.palette?.secondary?.main : theme.palette?.leftMenuText?.color} !important;
    width: ${({ fullWidth }) => fullWidth ? '100%' : 'auto'};
    div {
        div {
            display: flex;
            justify-content: center;
        }
    }
`;

const SvgWrapper = styled.div`
    width: ${({ fullWidth }) => fullWidth ? '100%' : 'auto'};
    div {
        div {
            display: flex;
            justify-content: center;
        }
    }

`

const Wrapper = { SVG_Wrapper, SvgWrapper };

export default Wrapper;
